
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`ນີ້ແມ່ນນໍາເອົາໂດຍ
                    <a href="${0}">ໂຄງການເຄື່ອງຈັກ Folksonomy</a>. ຢ່າ
                    ລັງເລທີ່ຈະເຂົ້າຮ່ວມ ຫຼືໃຫ້ຄໍາຄິດເຫັນ`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`ເຄື່ອງມືນີ້ຊ່ວຍໃຫ້ທ່ານແກ້ໄຂບັນຊີລາຍຊື່ສ່ວນປະກອບ. ທ່ານສາມາດເພີ່ມ, ລຶບ ຫຼືແກ້ໄຂລາຍການສ່ວນປະກອບ
                .
                <br>
                ລັກສະນະນີ້ <span class="highlight">␣</span> ເປັນຕົວແທນຂອງຊ່ອງ.
                <br>
                ຕົວລະຄອນນີ້ <span class="highlight">↩︎</span> ເປັນຕົວແທນຂອງຕົວແບ່ງແຖວ. `,
'hb28f1f2ec1744ee9': html`ຄຸນສົມບັດເຫຼົ່ານີ້ຖືກສ້າງ ແລະຍື່ນໂດຍຜູ້ໃຊ້ສໍາລັບການນໍາໃຊ້ປະເພດໃດນຶ່ງ. ຮູ້ສຶກວ່າ
                    ມີອິດສະລະທີ່ຈະເພີ່ມຂອງທ່ານເອງ. ຄຸນສົມບັດ ແລະຄ່າທີ່ທ່ານສ້າງ
                    <strong>ຕ້ອງເປັນຄວາມຈິງ</strong>. ທ່ານສາມາດເຂົ້າໄປໃນ
                    <a href="${0}">ບັນຊີລາຍຊື່ຂອງຄຸນສົມບັດທີ່ໃຊ້ແລ້ວໂດຍຊຸມຊົນ</a>
                    ຫຼືຄົ້ນຫາເອກະສານ
                    <a href="${1}">ແລະເຄື່ອງຈັກຊອກຫາຂອງມັນ</a>.`,
's000a5b76bd3a01c2': `ກຳລັງໂຫຼດຄຸນສົມບັດ...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `ຊ່ວຍພວກເຮົາສໍາລັບສ່ວນປະກອບ`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `ກວດສອບການຕັດ`,
's03e9c8114521b998': `ຂ້ອຍຈະແກ້ໄຂສ່ວນປະກອບ`,
's05ec315d9308091a': `ໄອຄອນມຸມບາໂຄດ`,
's061eb5af92512c85': `ບັນທຶກແລ້ວ! ເຈົ້າສາມາດຊ່ວຍຄົນອື່ນໄດ້ບໍ?`,
's06847c221c4c0bc1': `ຂ້ອຍຢາກສ້າງຊັບສິນເພື່ອ [ອະທິບາຍກໍລະນີການນຳໃຊ້ຂອງເຈົ້າ]...`,
's06f6c6f99db6b552': `ຕົ້ນສະບັບ`,
's081e2ad82db71e1d': `ມູນຄ່າກຸ່ມ`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `ເອກະສານສະເພາະ`,
's0bb2d48532acc455': `ດາວໂຫລດ CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `ຮູບພາບບໍ່ຖືກຕ້ອງ`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `ຍົກເລີກການປູກພືດ`,
's11a18a69b30b65ed': `ຊ່ວຍພວກເຮົາແກ້ໄຂຂໍ້ຜິດພາດໃນລາຍການສ່ວນປະກອບ`,
's1205d5f6fccf8e69': `ມູນຄ່າຊັບສິນ`,
's15d64a0a6715285a': `ກະແຈໃໝ່`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `ພື້ນທີ່ເລືອກ`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `ຊ່ວຍພວກເຮົາແກ້ໄຂຂໍ້ມູນໂພຊະນາການ`,
's1e00019dc454872d': `ກະລຸນາລະບຸຊື່ຊັບສິນໂດຍໃຊ້ຄຸນສົມບັດຊື່.`,
's1e49126af0935a5b': `ລາຍຊື່ຜະລິດຕະພັນທີ່ໃຊ້ຄຸນສົມບັດນີ້`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `ເອກະສານຊັບສິນ`,
's300b3a6ee4e1252d': str`ການແຂ່ງຂັນທີ່ບໍ່ດີ ${0}%`,
's33f786bb6b4f0cf4': `ຜົນການປູກພືດ`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `ຖາມຊຸມຊົນກ່ອນ`,
's36d86adc823cbfa6': `ກ່ອນທີ່ຈະສ້າງຊັບສິນໃຫມ່, ປຶກສາຫາລືກັບຊຸມຊົນ:`,
's3781d25aa51a736c': `ເອກະສານເຄື່ອງຈັກ Folksonomy`,
's383ae4449428b61e': `ຣີເຊັດການຕັດ`,
's39bcf88721a1e8ee': `ຣີເຊັດການເລືອກ`,
's39e14e14300694c7': `ເອກະສານ ແລະຂໍ້ແນະນຳ`,
's3b430cfa5c1fe7f4': str`ເອກະສານສໍາລັບ ${0}`,
's3f4e4b52f230a892': `ຜ້າໃບຮູບ`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `ຮູບກາງ`,
's42dd66b2441566fd': `ໄອຄອນກາງ`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `ປັບຂະໜາດຂວາ`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `ຈໍານວນຜະລິດຕະພັນ`,
's4df2f533c0c1e7d0': `ການຄວບຄຸມຮູບພາບ`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `ຍ້າຍການເລືອກ`,
's4f751fb9b3ed766c': `ການສ້າງຊັບສິນໃຫມ່`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `ໃສ່ຊື່ຊັບສິນ...`,
's55d7249883a98ca1': `ກ່ຽວກັບຊັບສິນນີ້ຢູ່ໃນ Open Food Facts wiki`,
's565867d84c04aea2': `ຄຸນສົມບັດການກັ່ນຕອງ...`,
's5666afe5cd0166de': `ກະລຸນາແກ້ໄຂຂໍ້ຜິດພາດ ຫຼືແກ້ໄຂຂໍ້ຄວາມກ່ອນທີ່ຈະຢືນຢັນ`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `ກຳລັງໂຫຼດສິນຄ້າ...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `ຊ່ວຍພວກເຮົາແກ້ໄຂຂໍ້ມູນໂພຊະນາການ.`,
's5dd6f12783fca34f': `ແກ້ໄຂລາຍການສ່ວນປະກອບ`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `ຕັດຮູບ`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`ການແຂ່ງຂັນທີ່ດີ ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `ເອກະສານ`,
's787dd11bed0dc88a': `ປັບຂະໜາດຊ້າຍ`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `ສຶກສາເພີ່ມເຕີມກ່ຽວກັບການສ້າງຊັບສິນ ແລະຂໍ້ແນະນຳ:`,
's8038273de2cf8b73': `ກະລຸນາເລືອກຂົງເຂດເພື່ອຕັດ.`,
's839cc2908a5387f2': `ກັ່ນຕອງບາໂຄດ...`,
's86197dcf3e96af64': `ຄົ້ນຫາແລະຄົ້ນຫາຄຸນສົມບັດທີ່ມີຢູ່`,
's8a63be30a129a59c': `ປັບຂະໜາດລຸ່ມ`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `ປັບຂະໜາດຂວາເທິງ`,
's8db84aa4bc949af2': `ເອກະສານຊັບສິນໃຫມ່`,
's8f839a03997a16d7': `ເບິ່ງຜະລິດຕະພັນ`,
's901ae1e236ac45d3': `ຍົກເລີກການລຶບ`,
's907f7a97c6b29425': `ລະວັງຕົວແບບຂໍ້ມູນອາດຈະຖືກແກ້ໄຂ. ໃຊ້ຢູ່ໃນຄວາມສ່ຽງຂອງທ່ານເອງ.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `ສ່ວນປະກອບ:`,
's9a7f60fce090ecaf': `ໂຫຼດຄຸນສົມບັດບໍ່ສຳເລັດ. ກະລຸນາລອງໃໝ່ໃນພາຍຫຼັງ.`,
's9b87abd68fb9df45': `ບໍ່ພົບ? ສ້າງລະຫັດໃຫມ່ {value}`,
's9c0f52425fd2f07e': `ອາດຈະບໍ່ກົງກັນ`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `ບໍ່ມີຄະແນນ`,
'sa548778b24054030': `ສຳຫຼວດຄຸນສົມບັດທີ່ປະກອບສ່ວນທັງໝົດຈາກໂຄງການ Folksonomy Engine. ຄຸນສົມບັດເຫຼົ່ານີ້ໃຫ້ຂໍ້ມູນ metadata ແລະຄວາມເຂົ້າໃຈເພີ່ມເຕີມກ່ຽວກັບຜະລິດຕະພັນໃນຖານຂໍ້ມູນ Open Food Facts.`,
'sa63907958bd0ec4b': `ປັບຂະໜາດເທິງຊ້າຍ`,
'sa95b4224f685a36a': `ປິດ modal`,
'sab56a1d439576fd6': `ໄອຄອນແນະນຳ`,
'sac47ea2901d04c15': `ປັບຂະໜາດລຸ່ມຊ້າຍ`,
'sb125227d436c2925': `ຊອກຫາແນວຄວາມຄິດຊັບສິນຂອງທ່ານໃນຖານຂໍ້ມູນຄຸນສົມບັດທີ່ມີຢູ່ແລ້ວ:`,
'sb125568d43642e6f': `ຕອບຄໍາຖາມກ່ຽວກັບຜະລິດຕະພັນ.`,
'sb1c538e038f9b214': str`ການແຂ່ງຂັນທີ່ດີຫຼາຍ ${0}%`,
'sb28639570ff3b852': `ບັນຊີລາຍຊື່ຂອງຄຸນສົມບັດທັງຫມົດ`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `ເມື່ອທ່ານໄດ້ຢັ້ງຢືນວ່າຊັບສິນຂອງທ່ານບໍ່ມີຢູ່ ແລະຊຸມຊົນຍອມຮັບວ່າມັນເປັນປະໂຫຍດ, ທ່ານຈໍາເປັນຕ້ອງໄດ້ບັນທຶກມັນຢູ່ໃນ wiki ທໍາອິດ.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `ບໍ່ພົບຜະລິດຕະພັນສໍາລັບຊັບສິນນີ້.`,
'sb7f72e4c8a2d3357': `ຄ່າການກັ່ນຕອງ...`,
'sb8178320160f84ea': `ສະແດງການຕັດ`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `ຄວາມເຂົ້າໃຈທັງຫມົດໄດ້ຮັບຄໍາຕອບ! ຂອບໃຈສໍາລັບການຊ່ວຍເຫຼືອຂອງທ່ານ!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `ມູນຄ່າທີ່ສອດຄ້ອງກັນ`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `ປັບຂະໜາດເທິງ`,
'sc1c08d0cbcc3bd24': `ບໍ່ກົງກັນ`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `ແນະນຳການແກ້ໄຂ`,
'sc681b137e8f604f7': `ຢືນຢັນການລຶບ`,
'sc6daf8a31883f8b9': `ຍ້າຍຮູບ`,
'sc895972c88d38ca5': `ຊັບສິນ Folksonomy`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `ແຖວ`,
'scb3b0671d7b7f640': `ຄ່າໃໝ່`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `ເຂົ້າຮ່ວມການສົນທະນາ Slack`,
'scdb6cad0b92721bf': `ບໍ່ພົບຄຸນສົມບັດ.`,
'scf23a05631f93732': `ຢືນຢັນການລຶບ`,
'scfed2f270ef6a3aa': `ເລືອກພື້ນທີ່`,
'sd1022bc1ef9204f7': `ຊູມໄດ້`,
'sd1077c055cf9ba6b': `ຊ່ວຍພວກເຮົາກວດສອບລາຍການສ່ວນປະກອບຂອງຜະລິດຕະພັນ.`,
'sd698d21ddecba56b': `ເຮີ້ຍ! ທ່ານສາມາດຊ່ວຍພວກເຮົາປັບປຸງຂໍ້ມູນຜະລິດຕະພັນໂດຍການຕອບພາກສ່ວນຕໍ່ໄປນີ້:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `ກວດເບິ່ງວ່າມີຊັບສິນຢູ່ແລ້ວ`,
'sdbf806fefc584115': `ທ່ານຄວນຊອກຫາ a`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `ຊ່ວຍພວກເຮົາແກ້ໄຂການສະກົດຄໍາຂອງສ່ວນປະກອບ.`,
'sdca5deead576ceee': `ປັບຂະໜາດລຸ່ມຂວາ`,
'sdcc2555c5dde524f': `ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບລາຍການນີ້? ຄຳສັ່ງນີ້ບໍ່ສາມາດຍົກເລີກໄດ້.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `ບໍ່ຖືກຕ້ອງ`,
'se5127cf0f92e7e48': `ຄໍາແນະນໍາ: ທ່ານຍັງສາມາດຊອກຫາໄດ້`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `ຂ້າພະເຈົ້າຈະສະເຫນີການປູກພືດທີ່ດີກວ່າ`,
'seea3800e27baa686': `ຜະລິດຕະພັນສ່ວນບຸກຄົນ`,
'sefaba4adc4ec9219': `ຄຸນສົມບັດ Folksonomy`,
'seffa8ca49175b5f0': `ຄຸນສົມບັດສ່ວນບຸກຄົນ`,
'sf44a6b3b232c28ea': str`ແທນທີ່ຄ່າປັດຈຸບັນໂດຍ ${0}`,
'sf4cd86a2f5ef2588': `ບາໂຄດສິນຄ້າ`,
'sf57a61152168cc81': `ຊ່ວຍພວກເຮົາແກ້ໄຂການກວດພົບສ່ວນປະກອບ`,
'sf88b90b8ba23871c': `ບໍ່ຮູ້ຈັກກົງກັນ`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `ຊື່ຊັບສິນ:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `ຄ່າທີ່ສອດຄ້ອງກັນ`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  